import { render, staticRenderFns } from "./TabStep.vue?vue&type=template&id=10617d9c&scoped=true&"
import script from "./TabStep.vue?vue&type=script&lang=js&"
export * from "./TabStep.vue?vue&type=script&lang=js&"
import style0 from "./TabStep.vue?vue&type=style&index=0&id=10617d9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10617d9c",
  null
  
)

export default component.exports